require('../modules/es.array.iterator');

var DOMIterables = require('../internals/dom-iterables');

var global = require('../internals/global');

var classof = require('../internals/classof');

var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

var Iterators = require('../internals/iterators');

var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;

  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
  }

  Iterators[COLLECTION_NAME] = Iterators.Array;
}